import React from "react";

function AdminOverviewCardChild(props) {
  console.log(props, "propssss");
  const { icon, value, status } = props.boxData;
  return (
      <div className="box-parent">
        <div className="inner-box-left">
          <img src={icon} alt="account-open-icon" />
        </div>
        <div className="inner-box-right">
          <span className="count-inner-box">{value}</span>
          <span className="status-inner-box">{status}</span>
        </div>
      </div>
  );
}

export default AdminOverviewCardChild;
